import * as actionTypes from './actionTypes'

export const mathTest = (state = {
  isFetching: true,
  isSubmiting: false,
  error: null,
}, action) => {
  switch (action.type) {
    case actionTypes.MATH_TEST_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.MATH_TEST_RECEIVE:
      return {
        ...state,
        ...action.data,
        isFetching: false,
      };
    case actionTypes.MATH_TEST_ERROR:
      return {
        ...state,
        didInvalidate: false,
        error: action.error,
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/store/mathTest/reducers.js